// extracted by mini-css-extract-plugin
module.exports = {"product-options-container":"_1xqPF","productOptionsContainer":"_1xqPF","productOptions":"_2Jg4B","quantity":"_1ZOt-","newAddToCartButton":"_2Jw9-"};